import React, { useState, Fragment } from "react";
import {
    Dialog,
    Slider,
    DialogContent as MuiDialogContent,
    DialogTitle,
    DialogActions,
    Grid,
    Button
} from "@material-ui/core";
import styled from "styled-components";
import { updateUserSubject } from "../../store/sagas/firebaseDataSync/clients/clients";
import { connect } from "react-redux";
import { userSubject } from "../../store/reducers";
import { SubjectChip } from "./SubjectChip";

const DialogContent = styled(MuiDialogContent)`
    min-width: 300px;
`;

const Margin = styled.div`
    height: 1.9rem;
`;

const getValueText = value => value * 10;

const connectRedux = connect((initState, { id }) => state => ({
    userValue: userSubject(id)(state)
}));

const EditableSubjectChip = connectRedux(topic => {
    const [isOpen, setIsOpen] = useState(false);
    const userValue = topic.userValue.value;
    const hasUserValue = userValue || userValue === 0;
    const initialValue = hasUserValue ? userValue : topic.defaultValue;
    const [topicValue, setTopicValue] = useState(initialValue);
    const handleChangeValue = (event, newValue) => {
        setTopicValue(newValue);
    };
    const closeEditor = () => setIsOpen(false);
    const openEditor = () => setIsOpen(true);

    const onDone = () => {
        closeEditor();
        const now = new Date();
        updateUserSubject({
            id: topic.id,
            value: topicValue,
            createdAt: topic.userValue.createdAt || now,
            changedAt: now
        });
    };

    return (
        <Fragment>
            <SubjectChip
                getValueText={getValueText}
                label={topic.name}
                onClick={openEditor}
                value={topicValue}
                valueType={hasUserValue ? "user" : "default"}
            />
            {isOpen && (
                <Dialog open={true} onClose={onDone}>
                    <DialogTitle>{topic.name}</DialogTitle>
                    <DialogContent>
                        <Margin />
                        <Grid container spacing={2}>
                            <Grid item>0</Grid>
                            <Grid item xs>
                                <Slider
                                    aria-label={`${topic.name} value`}
                                    min={0}
                                    max={1}
                                    step={0.1}
                                    value={topicValue}
                                    onChange={handleChangeValue}
                                    valueLabelDisplay="on"
                                    valueLabelFormat={getValueText}
                                />
                            </Grid>
                            <Grid item>10</Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            aria-label={`Done setting ${topic.name}`}
                            onClick={onDone}
                        >
                            Done
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </Fragment>
    );
});

export { EditableSubjectChip };



// WEBPACK FOOTER //
// ./src/components/start/EditableSubjectChip.js